// ProfileTabs.tsx — Tab strip for AccountPage.
// Tabs: Profile / Travellers / Preferences / Payment Methods

const F = '"Inter Variable","Inter",system-ui,sans-serif';

export type AccountTab = 'profile' | 'travellers' | 'preferences' | 'payment';

interface Tab {
  id: AccountTab;
  label: string;
}

const TABS: Tab[] = [
  { id: 'profile', label: 'Profile' },
  { id: 'travellers', label: 'Travellers' },
  { id: 'preferences', label: 'Preferences' },
  { id: 'payment', label: 'Payment methods' },
];

interface ProfileTabsProps {
  active: AccountTab;
  onChange: (tab: AccountTab) => void;
}

export function ProfileTabs({ active, onChange }: ProfileTabsProps) {
  return (
    <div style={{
      display: 'flex',
      gap: 4,
      padding: '4px',
      background: '#0A0F1C',
      borderRadius: 16,
      border: '1px solid rgba(255,255,255,0.07)',
    }}>
      {TABS.map(tab => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            style={{
              flex: 1,
              height: 40,
              borderRadius: 12,
              border: 'none',
              cursor: 'pointer',
              fontFamily: F,
              fontSize: 13,
              fontWeight: isActive ? 700 : 500,
              background: isActive ? '#131C30' : 'transparent',
              color: isActive ? '#F4F3F0' : '#8C98B0',
              transition: 'all 0.15s',
              whiteSpace: 'nowrap',
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
